// Modification provided by Searchanise team. With any questions, contact us at feedback@searchanise.io

document.addEventListener('Searchanise.Loaded', function() {
    // SETTINGS START
    
    const filterTranslations = {
        "Color": {
            "Bleu": "Blue",
            "Blanc": "White",
            "Brun": "Brown",
            "Gris": "Grey",
            "Noir": "Black",
            "Rouge": "Red",
            "Vert": "Green",
            "Autres couleurs": "Other colors",
            "Doré": "Golden",
            "Mauve": "Purple",
            "Rose": "Pink",
            "Beige": "Beige",
            "Orange": "Orange",
            "Neutre": "Neutral",
        },
        "Product Type": {  
            "Ballerine": "Ballet flats",
            "Base en caoutchouc": "Rubber base",
            "Base de caoutchouc": "Rubber base",
            "Botillons": "Ankle boots",
            "Bottillon": "Short boots",
            "Bottes de pluie": "Rain boots",
            "Bottes longues": "Tall boots",
            "Bottes mi-jambes": "Mid-calf boots",
            "Bottillons": "Booties",
            "Compensées": "Wedges",
            "Crampons": "Spikes",
            "De marche": "Walking shoes",
            "Fermé": "Closed",
            "Imperméables": "Waterproof",
            "Loafer": "Loafer",
            "Mule": "Mule",
            "Ouvertes": "Open",
            "Talons bas": "Low heels",
            "Talons hauts": "High heels",
            "Talons moyens": "Medium heels",
            "Botte a crampon": "Spiked boots",
            "Chaussures décontractées": "Casual shoes",
            "Chaussures imperméables": "Waterproof shoes",
            "Doublé laine de mouton": "Wool boots",
            "Doublé laine synthétique": "Warm boots",
            "Gore-tex / thinsulte": "Gore-tex / Thinsulate",
            "Habillées avec lacets": "Dress shoes with laces",
            "Habillées sans lacets": "Dress shoes without laces",
            "Pantouffles": "Slippers",
            "Sandales": "Sandals",
            "Bottes d'hiver": "Winter boots",
            "Bottines": "Ankle boots",
            "Bébé fille": "Toddler girl caps",
            "Bébé filles": "Toddler girl hats",
            "Bébé garcons": "Toddler boy hats",
            "Bébé garçon": "Toddler boy caps",
            "Chaussures": "Shoes",
            "Clé crampon": "Spike wrench",
            "Crampon": "Spike",
            "Enfant fille": "Girl caps",
            "Enfant filles": "Girl hats",
            "Enfant garcons": "Boy hats",
            "Enfant garçon": "Boy caps",
            "Entretien": "Shoe care",
            "Femme": "Women",
            "Feutres bébé": "Soles for babies",
            "Feutres enfants": "Soles for kids",
            "Fille": "Girls",
            "Garcon": "Boys",
            "Homme": "Men",
            "Mouton": "Sheep",
            "Pantouffle": "Slippers",
            "Porte-monnaie": "Wallets",
            "Sac a dos": "Backpacks",
            "Sacs de taille": "Waist bags",
            "Sacs sport": "Sports bags",
            "Étuis a crayons": "Pencil cases",
            "Sacs à mains": "Handbags",
            "Semelle": "Insoles",
            "Ballerine": "Ballet flats",
        "Base en caoutchouc": "Rubber base",
        "Base de caoutchouc": "Rubber base",
        "Botillons": "Ankle boots",
        "Bottillon": "Short boots",
        "Bottes de pluie": "Rain boots",
        "Chaussures talons hauts pour femme": "High heel shoes for women",
        "Chaussures talons moyens pour femme": "Mid heel shoes for women",
        "Chaussures talons bas pour femme": "Low heel shoes for women",
        "Chaussures compensees pour femme": "Platform shoes for women",
        "Chaussures loafer pour femme": "Loafer shoes for women",
        "Chaussures ballerine pour femme": "Ballet flat shoes for women",
        "Chaussures marche pour femme": "Walking shoes for women",
        "Chaussures mule pour femme": "Mule shoes for women",
        "Chaussures impermeable pour femme": "Waterproof shoes for women",
        "Sandales compensees pour femme": "Platform sandals for women",
        "Sandales talons hauts pour femme": "High heel sandals for women",
        "Sandales talons moyens pour femme": "Mid heel sandals for women",
        "Sandales talons bas pour femme": "Low heel sandals for women",
        "Sandales marche pour femme": "Walking sandals for women",
        "Bottes hiver crampons pour femme": "Winter crampons boots for women",
        "Bottes hiver caoutchouc pour femme": "Winter rubber boots for women",
        "Bottes hiver longues pour femme": "Long winter boots for women",
        "Bottes hiver mi jambes pour femme": "Mid-calf winter boots for women",
        "Bottes hiver botillons pour femme": "Winter ankle boots for women",
        "Bottes automne botillons pour femme": "Fall ankle boots for women",
        "Bottes automne mi jambes pour femme": "Mid-calf fall boots for women",
        "Bottes automne longues pour femme": "Long fall boots for women",
        "Bottes automne pluie pour femme": "Fall rain boots for women",
        "Pantouffles fermées pour femme": "Closed slippers for women",
        "Chaussures decontracte pour homme": "Casual shoes for men",
        "Chaussures habillé avec lacets pour homme": "Dress shoes with laces for men",
        "Chaussures habillé sans lacets pour homme": "Dress shoes without laces for men",
        "Chaussures impermeable pour homme": "Waterproof shoes for men",
        "Sandales pour homme": "Sandals for men",
        "Pantouffles pour homme": "Slippers for men",
        "Bottes crampons pour homme": "Crampons boots for men",
        "Bottes double laine mouton pour homme": "Double sheep wool boots for men",
        "Bottes double laine synthétiques pour homme": "Double synthetic wool boots for men",
        "Bottes gore-tex / thinsulate pour homme": "Gore-tex / thinsulate boots for men",
        "Bottes caoutchouc pour homme": "Rubber boots for men",
        "Bottillon pour homme": "Short boots for men",
        "Bottes hiver bébé garçon": "Winter boots baby boy",
        "Bottes automne bébé garçon": "Fall boots baby boy",
        "Sandales bébé garçon": "Sandals baby boy",
        "Espadrilles / chaussures bébé garçon": "Sneakers / shoes baby boy",
        "Bottes de pluie bébé garçon": "Rain boots baby boy",
        "Pantouffles bébé garçon": "Slippers baby boy",
        "Bottines bébé garçon": "Booties baby boy",
        "Bottes hiver bébé fille": "Winter boots baby girl",
        "Bottes automne bébé fille": "Fall boots baby girl",
        "Sandales bébé fille": "Sandals baby girl",
        "Espadrilles / chaussures bébé fille": "Sneakers / shoes baby girl",
        "Bottes de pluie bébé fille": "Rain boots baby girl",
        "Pantouffles bébé fille": "Slippers baby girl",
        "Bottines bébé fille": "Booties baby girl",
        "Sport bébé fille": "Sport baby girl",
        "Bottes hiver garçon": "Winter boots boy",
        "Bottes automne garçon": "Fall boots boy",
        "Sandales garçon": "Sandals boy",
        "Espadrilles / chaussures garçon": "Sneakers / shoes boy",
        "Bottes de pluie garçon": "Rain boots boy",
        "Pantouffles garçon": "Slippers boy",
        "Sport garçon": "Sport boy",
        "Bottes hiver fille": "Winter boots girl",
        "Bottes automne fille": "Fall boots girl",
        "Sandales fille": "Sandals girl",
        "Espadrilles / chaussures fille": "Sneakers / shoes girl",
        "Bottes de pluie fille": "Rain boots girl",
        "Pantouffles fille": "Slippers girl",
        "Sport fille": "Sport girl",
        "Entretien chaussures": "Shoe care",
        "Lacets": "Laces",
        "Clé crampon": "Crampon key",
        "Crampon": "Crampon",
        "Semelles mouton": "Sheep wool insoles",
        "Semelles feutres bébé": "Felt insoles baby",
        "Semelles feutres enfants": "Felt insoles children",
        "Semelles": "Insoles",
        "Sacs à mains": "Handbags",
        "Sacs à dos": "Backpacks",
        "Sacs de taille": "Waist bags",
        "Sacs sport": "Sport bags",
        "Étuis à crayons": "Pencil cases",
        "Boites à lunch": "Lunch boxes",
        "Porte-monnaie": "Wallets",
        "Bas pour femme": "Socks for women",
        "Bas pour homme": "Socks for men",
        "Bas fille": "Socks girl",
        "Bas garçon": "Socks boy",
        "Casquettes bébé fille": "Caps baby girl",
        "Casquettes bébé garçon": "Caps baby boy",
        "Casquettes enfant fille": "Caps girl child",
        "Casquettes enfant garçon": "Caps boy child",
        "Tuques bébé garçon": "Beanie hats baby boy",
        "Tuques bébé fille": "Beanie hats baby girl",
        "Tuques enfant fille": "Beanie hats girl child",
        "Tuques enfant garçon": "Beanie hats boy child",
        "Tuques pour femme": "Beanie hats for women",
        },
        "Width": {
            "Étroit": "Narrow",
            "Médium": "Medium"
        },
        "Discount": {
            "Prix régulier": "Regular price"
        },
        "Size": {
            "Aucune": "None",
            "Taille unique": "One size fits all"
        }
    };

    // SETTINGS END. DON'T EDIT THE CODE BELOW.

    (function($) {

        function translateFacets(data, type) {
            if (Shopify.locale == 'fr' || !data?.facets?.length || type !== 'results') { return }
            
            for (f of data.facets) {
                if (filterTranslations[f?.title]) {
                    for (v of f.buckets) {
                        // Store original value if not already stored
                        if (!v.original_value) {
                            v.original_value = v.value;
                        }
                        
                        // Only translate the title (display text), keep value unchanged
                        if (!v.title) v.title = v.value;
                        
                        if (v?.title && filterTranslations[f.title][v.title]) {
                            v.title = filterTranslations[f.title][v.title];
                        }
                        
                        // IMPORTANT: Don't translate v.value - it's used for filtering
                        // The value property must remain in French for Searchanise to work
                    }
                }
            }
        }

        $(document).on('Searchanise.DataRequestEnd', function(e, type, params, data) {
            translateFacets(data, type);
        });

    })(window.Searchanise.$);
});